import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation4 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };


    return (
      




        <div className="container mt-1 p-3 mb-1" style={{ }}>


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in Advanced Excel

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>
            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Advanced Excel
                </h5>
                <p>
                    Excel skills are as important as the subject knowledge. Those who know Excel can find a better paying job. An Excel Expert collects, edits, analyses data, creates data bases and reports. The conclusions made by the data expert are helpful for organizations to forecast the business speculations.  </p>

                <hr />
            </div>
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>
            <p>After completion of the course, you can get a suitable position in any organization as an Accounts Assistant, Finance Analyst, Retail Store Manager and Data Analyst in any organization.</p>

            <hr />
            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Advance Excel course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>
                <hr />
            </div>
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <ol>
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                       
                    </ol>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>
            <p>The syllabus covers the following skills:</p>
            <ul>

                <li>Apply custom formats and layouts</li>
                <li> Create advanced formulas</li>
                <li> Use of Scenario</li>
                <li> Pivot tables and charts</li>
                <li> Manage and share workbooks</li>
            </ul>
            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Basics of Data Management</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Introduction to Data Management</li>
                                <li>How do professionals organize their data?</li>
                                <li>Meta Data and Big Data</li>
                                <li>Freelance Data Entry Jobs</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Introduction to Computer Typing and Data Entry </AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Introduction to Typing</li>
                                <li>Keyboarding</li>
                                <li> Ergonomic Typing</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Introduction to various Typing Methods</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Using different types of keys and symbols in typing Google Docs – Voice Typing Lipikaar App</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Introduction to Data Anaylsis</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li> Using different types of keys and symbols in typing</li>
                                <li>Google Docs – Voice Typing</li>
                                <li>Lipikaar App</li>
                                <li>Text Formulas</li>
                                <li>Text Manipulation Functions</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Apply Custom Formats and Layouts</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Apply Custom Data Formats</li>
                                <li> Use Advanced Fill Options</li>
                                <li>Apply Advanced Conditional Formatting and Filtering</li>
                                <li>Apply Custom Styles and Templates</li>
                                <li>Use Form Controls</li>
                                <li>Prepare Workbooks for Internationalization</li>
                                <li>Use Outlines</li>
                                <li>Use Custom Views</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Create Advanced Charts </AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Basic Excel Charts</li>
                                <li>Use Area, Scatter & Stock Charts</li>
                                <li>Use Surface, Radar & Combination Charts</li>
                                <li>Create Custom Chart Templates</li>
                                <li>Work with Sparkline’s</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Pivot tables and charts</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li> Pivot Tables</li>
                                <li>Use Pivot Charts</li>
                                <li>Create Dashboard using Pivot Table</li>
                                <li>Using Power Query</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Data Visualisation and Data Analysis</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Use of Macros</li>
                                <li>Using Data Tables</li>
                                <li>Create Dashboard using Pivot Table</li>
                                <li>Using Power Query</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Use Scenarios</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>Use What-If Analysis Tools</li>
                                <li>Create Scenarios</li>
                                <li>Merge Scenarios</li>
                                <li>Create Scenario Summaries</li>
                                <li>Use Data Tables</li>
                            </ul>


                        </AccordionBody >
                    </AccordionItem >
                </Accordion >
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Manage and Share Workbooks</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li> Manage Workbook Versions</li>
                                <li> Copy Styles between Workbooks</li>
                                <li> Copy Macros between Workbooks</li>
                                <li> Use Track Changes and Comments</li>
                                <li> Merge Workbooks</li>
                                <li> Protect Workbooks for Sharing</li>
                                <li> Connect To External Data</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Typical Data Entry Projects</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li>File Conversion from PDF to Word</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="18">Create advanced Formulas</AccordionHeader>
                        <AccordionBody accordionId="18">
                            <ul>
                                <li> Functions</li>
                                <li> Apply functions in formulas</li>
                                <li> Mathematical Functions</li>
                                <li> Financial functions</li>
                                <li> Useful Data Functions</li>
                                <li> Some Other Useful Functions</li>
                                <li> Look up data by using functions</li>
                                <li> Apply advanced date and time functions</li>
                                <li> Functions for Manipulating Text</li>
                                <li> Arrays</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="19">Free and Open-Source Tools for Data management</AccordionHeader>
                        <AccordionBody accordionId="19">
                            <ul>
                                <li>Working with Google Sheets</li>
                                <li>Working with Google Forms</li>
                                <li>Working with Google Keep</li>
                                <li>Using OpenOffice.org Writer</li>
                                <li> Using OpenOffice.org Calc</li>
                                <li>Using Komprehend</li>
                                <li>Using Google Data Studio</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="20">Different Data Entry Methods and Data Cleaning </AccordionHeader>
                        <AccordionBody accordionId="20">
                            <ul>
                                <li>Using Komprehend</li>
                                <li> Excel Shortcuts</li>
                                <li>Mail Merge in MS Word</li>
                                <li>Compare Docs using MS Word</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="21">Introduction to DBMS</AccordionHeader>
                        <AccordionBody accordionId="21">
                            <ul>
                                <li>What is a DBMS and its purpose?</li>
                                <li>Types of DBMS</li>
                                <li>Examples of DBMS - MySQL, Oracle, etc.</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>




            </div >

            <h5>Outputs:</h5>
            <li>Organizing the data professionally, Using Metadata and Big Data, Internationalization for Excel Workbooks, data segregation using custom formats and layouts, Dashboard creation using Power Query and Power Pivot table, Using Power Map, Connecting Excel workbooks to external data, preparing a checklist for data collection using Canva, Data collection for social media marketing</li>
            <br />
            <hr />



            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
   
    );
}
export default CertificateInformation4;